import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, of } from "rxjs";
import { AppRoutingConstants } from "../../app-routing.constants";
import { ModuleConfigService } from "./module-config/module-config.service";
import { map, switchMap, take } from "rxjs/operators";
import { AuthService } from "./auth/auth.service";
import { UserInformationService } from "./user/user-information.service";
let SystemModuleSettingsService = class SystemModuleSettingsService {
    httpClient;
    moduleConfigService;
    authService;
    userInformation;
    $systemModuleSettingsFetched;
    systemModuleSettingsSubject = new BehaviorSubject(null);
    $systemModuleSettings = this.systemModuleSettingsSubject.asObservable();
    _configName = "ViewerConfigFile";
    $isAuthenticated;
    subscribToStrategyServiceSubject = new BehaviorSubject(null);
    $subscribToStrategyService = this.subscribToStrategyServiceSubject.asObservable();
    settingsSubscription;
    constructor(httpClient, moduleConfigService, authService, userInformation) {
        this.httpClient = httpClient;
        this.moduleConfigService = moduleConfigService;
        this.authService = authService;
        this.userInformation = userInformation;
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.setupSystemModuleSettingsFetched();
        this.listenForAuthenticationChanges();
    }
    getSystemModuleSettingsRequest() {
        const params = {
            $filter: `Key eq '${this._configName}'`
        };
        return this.httpClient
            .get(AppRoutingConstants.createEndpointRoutev2("ModuleSetting"), { params })
            .pipe(map((moduleSettings) => {
            this.setModuleConfigs(moduleSettings.value);
            this.systemModuleSettingsSubject.next(moduleSettings.value);
            return moduleSettings.value;
        }));
    }
    getSystemModuleSettings() {
        this.getSystemModuleSettingsRequest().pipe(take(1)).subscribe();
    }
    updateSystemModuleSettingsRequest(moduleSettingId, moduleSettings) {
        return this.httpClient.patch(`${AppRoutingConstants.createEndpointRoutev2("ModuleSetting")}/${moduleSettingId}`, { value: moduleSettings.value });
    }
    saveSystemModuleSettingsRequest(moduleSettings) {
        return this.httpClient.post(`${AppRoutingConstants.createEndpointRoutev2("ModuleSetting")}`, moduleSettings);
    }
    SetsubscribToStrategyServiceSubject(data) {
        this.subscribToStrategyServiceSubject.next(data);
    }
    setModuleConfigs(value) {
        value.forEach((systemModuleSetting) => {
            this.moduleConfigService.addModuleConfigName(systemModuleSetting.moduleId, systemModuleSetting.value);
        });
    }
    listenForAuthenticationChanges() {
        this.settingsSubscription = this.$isAuthenticated.pipe(switchMap(isAuthenticated => {
            if (isAuthenticated)
                return this.userInformation.$userInformationFetched;
            else
                return of(false);
        })).subscribe((userInformationFetched) => {
            if (userInformationFetched) {
                this.getSystemModuleSettings();
            }
        });
    }
    setupSystemModuleSettingsFetched() {
        this.$systemModuleSettingsFetched = this.$systemModuleSettings.pipe(map((systemModuleSettings) => {
            return systemModuleSettings != null;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: ModuleConfigService },
        { type: AuthService },
        { type: UserInformationService }
    ];
};
SystemModuleSettingsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SystemModuleSettingsService);
export { SystemModuleSettingsService };
